import React from 'react';
import '../../App';
import Contact from '../Contact';

export default function SignUp() {
  return <Contact/>;
}
